import { useTranslation } from 'react-i18next'

import { Box, Button, Flex, Text } from '@hivewatch/dark'

import type { SettingsSectionDefinition } from '../types/types'

interface SettingsSectionActionsIProps {
  colorScheme: 'light' | 'dark'
  section: SettingsSectionDefinition
}

const getColorToken = (colorScheme: 'light' | 'dark', token: string) =>
  colorScheme === 'light' ? `light.${token}` : token

export const SettingsSectionActions = ({
  colorScheme,
  section,
}: SettingsSectionActionsIProps) => {
  const { t } = useTranslation()
  const { actions, dirtyState } = section

  if (!actions && !dirtyState) {
    return null
  }

  const errorText = getColorToken(colorScheme, 'status.error-text')
  const successText = getColorToken(colorScheme, 'status.success-text')
  const isSaveDisabled =
    !dirtyState?.hasUnsavedChanges || dirtyState.status === 'validation-error'

  return (
    <Flex alignItems='center' gap='12px'>
      <Box aria-live='polite'>
        {dirtyState?.status === 'validation-error' && (
          <Text color={errorText} textStyle='caption'>
            {t('settings:rebrand_validation_error')}
          </Text>
        )}
        {dirtyState?.status === 'save-error' && (
          <Text color={errorText} textStyle='caption'>
            {t('settings:rebrand_save_error')}
          </Text>
        )}
        {dirtyState?.status === 'saved' && (
          <Text color={successText} textStyle='caption'>
            {t('settings:rebrand_changes_saved')}
          </Text>
        )}
      </Box>
      {actions}
      {dirtyState && (
        <Button
          colorScheme={colorScheme}
          disabled={isSaveDisabled}
          isLoading={dirtyState.status === 'saving'}
          onClick={() => void dirtyState.save()}
          variant='primary'
        >
          {t('settings:rebrand_save_changes')}
        </Button>
      )}
    </Flex>
  )
}
